import { Box, Button, Container, Typography } from "@mui/material";

const NotFound = () => (
  <Container
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      p: 10,
      flexDirection: "column",
      flex: 1,
      height: "100vh",
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        mb: 5,
      }}
    >
      <Typography fontSize={200} color={"error"}>
        404
      </Typography>
      <Typography fontSize={30} fontWeight={700}>
        Sorry, Page Not Found
      </Typography>
      <Typography fontSize={16} fontWeight={500}>
        The page you requested could not be found
      </Typography>
    </Box>
    <Box sx={{ p: 5 }}>
      <Button onClick={() => (window.location.href = "/")} variant="contained">
        Return home
      </Button>
    </Box>
  </Container>
);

export default NotFound;
